/* eslint-disable max-lines */
import moment from 'moment';
import {FLOAT_CLIENT_CODE} from './constants';
import {
  validateEmailCase,
  validateEmpty,
  validateId,
  validateLengthId,
  validateNumber,
  validateRucLength,
  validateTextUpperCase,
  validateUpperCaseAndSpecial,
} from '../floatingInventory/components/main/form/validations/validations';
import {noTimeZoneShortISODate} from '../common/constants/datesFormat';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

const colors = ['color-1', 'color-2', 'color-3', 'color-4', 'color-5'];

const dateFormat = 'YYYY-MM-DD';
export const validateDate = (dates, startDate, endDate) => {
  let result = false;
  const datesRange = range(startDate, endDate);

  datesRange.forEach((currentDate) => {
    dates.forEach((date) => {
      const endD = moment(date.endDate)
        .add(1, 'days')
        .format(dateFormat);
      const startD = moment(date.startDate)
        .add(-1, 'days')
        .format(dateFormat);
      const validate = moment(currentDate).isBetween(startD, endD);
      if (validate) {
        result = true;
      }
    });
  });

  return result;
};

export const rangeDates = (dates = []) => {
  return dates.map((date, index) => {
    const obj = {};
    const endD = moment(date.endDate).format(dateFormat);
    const startD = moment(date.startDate).format(dateFormat);
    obj[colors[index]] = range(startD, endD);
    return obj;
  });
};

function range(startDate, endDate) {
  const dates = [];
  const endD = moment(endDate).date();
  const startD = moment(startDate).date();
  const len = endD - startD;

  for (let i = 0; i <= len; i++) {
    dates.push(moment(startDate).add(i, 'days').toDate());
  }

  return dates;
}

export const validateEmptyFields = (arr) => {
  return arr.some((val) => {
    const validate = val.name === '' || val.segment === '' || val.idx === '';
    return validate;
  });
};

export const validateDates = (startDate, endDate) => {
  const validObj = {
    'isValid': true,
    'message': '',
  };
  if (!startDate || !endDate) {
    return {
      'isValid': false,
      'message': 'Formulario incompleto.',
    };
  }
  if (startDate > endDate) {
    validObj.isValid = false;
    validObj.message = 'Petición no procesada, el mes de la fecha final debe de ser mayor al mes de la fecha inicial.';
  }
  return validObj;
};

export const roundNumber = (number) => Math.round(number * 10) / 10;

export const parseDisabilityPerc = (disabilityPerc) => {
  return disabilityPerc.map((perc) => {
    return {
      'text': `${perc.disabilityPercentajeFrom} - ${perc.disabilityPercentajeTo}`,
      'value': perc.exonerationPercentaje,
    };
  });
};

export const getExonerationPerc = (clientType, discapacityPerc, exonerationList) => {
  if (clientType === FLOAT_CLIENT_CODE.PROUCTIVE_TRUCK) {
    return 'EXONERACION DE ICE';
  }
  if (clientType === FLOAT_CLIENT_CODE.DISABLED) {
    const discapacityPercValue = parseInt(discapacityPerc, 10);
    for (let i = 0; i < exonerationList.length; i++) {
      if (discapacityPercValue >= exonerationList[i]?.disabilityPercentajeFrom &&
          discapacityPercValue <= exonerationList[i]?.disabilityPercentajeTo) {
        return `${exonerationList[i]?.exonerationPercentaje || ''}`;
      }
    }
    return '';
  }
  if (clientType) {
    return '100';
  }
  return '';
};

const removeDuplicates = (arr, key) => {
  return Array.from(new Set(arr.map((a) => a[key]))).map(
    (id) => {
      return arr.find((a) => a[key] === id);
    }
  );
};

export const mapListToDropdownList = (list, {keys, values, texts}, allOption = false) => {
  if (list) {
    const listDropdown = [{
      'key': '',
      'value': '',
      'text': 'TODOS',
    }];

    const listData = list.map((item) => {
      const itemKey = keys.map((key) => item[key]).join('-');
      const itemValues = keys.map((key) => item[values]).join('-');
      const itemTexts = keys.map((key) => item[texts]).join('-');
      return {
        'key': itemKey,
        'value': itemValues,
        'text': itemTexts || '(Sin nombre)',
      };
    });
    const listWithoutDuplicates = removeDuplicates(listData, 'key');

    if (allOption) {
      return listDropdown.concat(listWithoutDuplicates);
    }
    return listWithoutDuplicates;
  }
  return [];
};

const urltoFile = async(url, filename, mimeType) => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, {'type': mimeType});
};
export const convertBase64ToFile = async(item) => {
  if (!item) {
    return null;
  }
  const base64 = `data:application/pdf;base64, ${item.file}`;
  return await urltoFile(base64, item.name, item.mimetype);
};

export const convertBase64ToFiles = (attachments) => {
  if (!attachments) {
    return null;
  }
  return Promise.all(attachments.map((item) => {
    const base64 = `data:application/pdf;base64, ${item.file}`;
    return urltoFile(base64, item.name, item.mimetype);
  }));
};

export const formValidationsClient = {
  'documentType': (data) => [validateEmpty],
  'dealerRuc': (data) => [validateEmpty],
  'document': (data) => {
    if (data.documentType === 'C') {
      return [validateEmpty, validateUpperCaseAndSpecial, validateId, validateNumber, validateLengthId];
    }
    if (data.documentType === 'R') {
      return [validateEmpty, validateUpperCaseAndSpecial, validateNumber, validateRucLength];
    }
    if (data.documentType === 'P') {
      return [validateEmpty, validateUpperCaseAndSpecial, validateLengthId];
    }
    return [validateEmpty, validateUpperCaseAndSpecial];
  },
  'names': (data) => {
    if (data.documentType === 'R') {
      return [validateTextUpperCase];
    }
    return [validateEmpty, validateTextUpperCase];
  },
  'lastNames': (data) => {
    if (data.documentType === 'R') {
      return [validateEmpty, validateUpperCaseAndSpecial];
    }
    return [validateEmpty, validateTextUpperCase];
  },
  'clientType': (data) => [validateEmpty],
  'certificate': (data) => [],
  'discapacityPerc': (data) => {
    if (data.clientType === '001') {
      return [validateEmpty, validateNumber];
    }
    return [];
  },
  'hasLegalRepresentative': (data) => [],
  'legalRepresentativeType': (data) => {
    if (data.hasLegalRepresentative === 'S') {
      return [validateEmpty];
    }
    return [];
  },
  'legalRepresentativeId': (data) => {
    if (data.hasLegalRepresentative === 'S') {
      if (data.legalRepresentativeType === 'C') {
        return [validateEmpty, validateUpperCaseAndSpecial, validateId, validateNumber, validateLengthId];
      }
      if (data.legalRepresentativeType === 'R') {
        return [validateEmpty, validateUpperCaseAndSpecial, validateNumber, validateRucLength];
      }
      if (data.legalRepresentativeType === 'P') {
        return [validateEmpty, validateUpperCaseAndSpecial, validateLengthId];
      }
      return [];
    }
    return [];
  },
  'legalRepresentativeName': (data) => {
    if (data.hasLegalRepresentative === 'S') {
      if (data.legalRepresentativeType === 'R') {
        return [validateEmpty, validateUpperCaseAndSpecial];
      }
      return [validateEmpty, validateTextUpperCase];
    }
    return [];
  },
  'location': (data) => [validateUpperCaseAndSpecial],
  'city': (data) => [validateUpperCaseAndSpecial],
  'province': (data) => [validateUpperCaseAndSpecial],
  'country': (data) => [validateUpperCaseAndSpecial],
  'phoneNumber': (data) => [validateUpperCaseAndSpecial, validateNumber],
  'email': (data) => [validateEmailCase],
  'contributorCode': (data) => [],
};


const generateExcelValue = (key, value, row) => {
  if (key.includes('Date')) {
    return value ? value.substring(0, 10) : value;
  }
  if (key === 'daysInDeposit') {
    return value ? value.split('/')[0] : value;
  }
  if (key === 'reserveAdvance') {
    return row.reserveAdvanceText;
  }
  return value;
};

const formatData = (data, titles) => {
  return data.map(((row) => {
    const newRow = {};
    titles.map((key) => {
      newRow[key] = generateExcelValue(key, row[key], row);
    });
    return newRow;
  }));
};

const generateTitles = () => {
  const titles = {
    'katashiki': 'KATASHIKI',
    'sfx': 'SFX',
    'model': 'MODELO',
    'startDate': 'DESDE',
    'endDate': 'HASTA',
    'currency': 'MONEDA',
    'fob': 'VALOR FOB',
    'outdoorColor': 'COLOR EXTERIOR',
    'outdoorColorDesc': 'COLOR EXTERIO NOMBRE',
    'indoorColor': 'COLOR INTERIOR',
    'indoorColorDesc': 'COLOR INTERIOR NOMBRE',
    'colorValue': 'VALOR COLOR',
    'commission': 'COMISIÓN',
    'shippingCost': 'FLETE',
    'cif': 'C&F',
  };

  const titleArray = Object.entries(titles).map(([key, value]) => {
    return value;
  });
  const titleItems = Object.entries(titles).map(([key, value]) => {
    return key;
  });
  const firstLine = Object.keys(titles).map((key) => {
    return key === 'startDate' ? 'VIGENCIA - PRODUCCIÓN' : '';
  });
  return {titleArray, titleItems, firstLine};
};

export const handleExcelColorPrices = (dataRaw) => {
  const date = moment().format(noTimeZoneShortISODate);
  const {'titleArray': titles, titleItems, firstLine} = generateTitles();
  const data = formatData(dataRaw, titleItems);
  const ws = XLSX.utils.book_new();
  XLSX.utils.sheet_add_aoa(ws, [firstLine]);
  XLSX.utils.sheet_add_aoa(ws, [titles], {
    'origin': 'A2',
  });

  XLSX.utils.sheet_add_json(ws, data, {
    'origin': 'A3',
    'skipHeader': true,
  });
  const wb = {'Sheets': {'data': ws}, 'SheetNames': ['data']};
  const excelBuffer = XLSX.write(wb, {
    'type': 'array',
    'cellStyles': true,
  });
  const finalData = new Blob([excelBuffer], {'type': 'xlsx'});
  FileSaver.saveAs(finalData, `TEMS-Reporte-Vehículos-Colores-${date}.xlsx`);
};

export const transformExcelData = (data) => {
  const response = {...data};
  for (const key in response) {
    for (let i = 0; i < response[key].content.length; i++) {
      for (const cell in response[key].content[i]) {
        response[key].content[i][cell] = true;
      }
    }
  }
  return response;
};
